import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row align-items-end" }
const _hoisted_2 = { class: "col-xl-3 col-lg-4 col-md-6 col-12" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "filtro-sucursal"
}, "Sucursal", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-xl-1 col-lg-2 col-md-2 col-4" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "filtro-anio"
}, "Gestión", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-xl-2 col-lg-2 col-md-2 col-4" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "filtro-mes"
}, "Mes", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col-xl-1 col-lg-2 col-md-2 col-4" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "filtro-dia"
}, "Día", -1)
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "— Todos —", -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col-xl-5 col-lg-12 col-12" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-excel" }, null, -1)

import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';

import useAuth from '@/modules/auth/composables/useAuth';
import useReportes, { FiltrosReporte } from '../composables/useReportes';


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltroReporteComponent',
  emits: ["ver", "exportar"],
  setup(__props, { emit }: { emit: ({
    (e: 'ver', filtros: FiltrosReporte): void;
    (e: 'exportar', filtros: FiltrosReporte): void;
}), expose: any, slots: any, attrs: any }) {



const store = useStore();
const { tienePermiso } = useAuth();
const { obtenerSucursalesHabilitadas } = useReportes();

// Solo quien administra el sistema elige la sucursal; el resto consulta su sucursal activa.
const esAdministrador = tienePermiso('administracion');
const nombreSucursalActiva = store.getters['auth/getSucursal'];

const hoy = new Date();
const anioActual = hoy.getFullYear();

const idSucursal = ref<number>(store.getters['auth/getIdSucursal']);
const anio = ref<number>(anioActual);
const mes  = ref<number>(hoy.getMonth() + 1);
const dia  = ref<number>(0);

const sucursales = ref<{ id: number, text: string }[]>([]);

const anios = Array.from({ length: anioActual - 2023 }, (_, i) => anioActual - i);

const meses = [
    { value: 0,  label: '— Todos —' },
    { value: 1,  label: 'Enero' },     { value: 2,  label: 'Febrero' },
    { value: 3,  label: 'Marzo' },     { value: 4,  label: 'Abril' },
    { value: 5,  label: 'Mayo' },      { value: 6,  label: 'Junio' },
    { value: 7,  label: 'Julio' },     { value: 8,  label: 'Agosto' },
    { value: 9,  label: 'Septiembre' },{ value: 10, label: 'Octubre' },
    { value: 11, label: 'Noviembre' }, { value: 12, label: 'Diciembre' },
];

const dias = computed(() => {
    if (mes.value === 0) return [];
    const totalDias = new Date(anio.value, mes.value, 0).getDate();
    return Array.from({ length: totalDias }, (_, i) => i + 1);
});

// Si cambia el mes o la gestión y el día ya no existe (o se eligió "Todos" los meses), se limpia.
watch([anio, mes], () => {
    if (mes.value === 0 || dia.value > dias.value.length) dia.value = 0;
});

const filtros = (): FiltrosReporte => ({
    idSucursal: idSucursal.value,
    anio: anio.value,
    mes: mes.value,
    dia: mes.value === 0 ? 0 : dia.value,
});

onMounted(async () => {
    if (esAdministrador) {
        sucursales.value = await obtenerSucursalesHabilitadas();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_unref(esAdministrador))
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              id: "filtro-sucursal",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((idSucursal).value = $event)),
              class: "form-control form-control-sm"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sucursales.value, (s) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: s.id,
                  value: s.id
                }, _toDisplayString(s.text), 9, _hoisted_5))
              }), 128))
            ], 512)), [
              [
                _vModelSelect,
                idSucursal.value,
                void 0,
                { number: true }
              ]
            ])
          : (_openBlock(), _createElementBlock("input", {
              key: 1,
              id: "filtro-sucursal",
              type: "text",
              class: "form-control form-control-sm",
              value: _unref(nombreSucursalActiva),
              readonly: ""
            }, null, 8, _hoisted_6))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("select", {
          id: "filtro-anio",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((anio).value = $event)),
          class: "form-control form-control-sm"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(anios), (a) => {
            return (_openBlock(), _createElementBlock("option", {
              key: a,
              value: a
            }, _toDisplayString(a), 9, _hoisted_10))
          }), 128))
        ], 512), [
          [
            _vModelSelect,
            anio.value,
            void 0,
            { number: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("select", {
          id: "filtro-mes",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mes).value = $event)),
          class: "form-control form-control-sm"
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(meses, (m) => {
            return _createElementVNode("option", {
              key: m.value,
              value: m.value
            }, _toDisplayString(m.label), 9, _hoisted_14)
          }), 64))
        ], 512), [
          [
            _vModelSelect,
            mes.value,
            void 0,
            { number: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _withDirectives(_createElementVNode("select", {
          id: "filtro-dia",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dia).value = $event)),
          class: "form-control form-control-sm",
          disabled: mes.value === 0
        }, [
          _hoisted_19,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dias), (d) => {
            return (_openBlock(), _createElementBlock("option", {
              key: d,
              value: d
            }, _toDisplayString(d), 9, _hoisted_20))
          }), 128))
        ], 8, _hoisted_18), [
          [
            _vModelSelect,
            dia.value,
            void 0,
            { number: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-sm mr-2",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('ver', filtros())))
        }, [
          _hoisted_23,
          _createTextVNode(" Ver reporte ")
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success btn-sm",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('exportar', filtros())))
        }, [
          _hoisted_24,
          _createTextVNode(" Exportar Excel ")
        ])
      ])
    ])
  ]))
}
}

})